import { Mode } from '../../enums';
import css from './style.module.css';

export const modePresets: Record<Mode, string> = {
  [Mode.DEFAULT]: css.default,
  [Mode.AMBIENT]: css.ambient,
  [Mode.WHITE]: css.white,
};
